/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssetTypeSubsystemComponentClassRequestDto
 */
export interface CreateAssetTypeSubsystemComponentClassRequestDto {
    /**
     * Array of associated component class IDs
     * @type {Array<string>}
     * @memberof CreateAssetTypeSubsystemComponentClassRequestDto
     */
    associatedComponentClassIds: Array<string>;
}

/**
 * Check if a given object implements the CreateAssetTypeSubsystemComponentClassRequestDto interface.
 */
export function instanceOfCreateAssetTypeSubsystemComponentClassRequestDto(value: object): value is CreateAssetTypeSubsystemComponentClassRequestDto {
    if (!('associatedComponentClassIds' in value) || value['associatedComponentClassIds'] === undefined) return false;
    return true;
}

export function CreateAssetTypeSubsystemComponentClassRequestDtoFromJSON(json: any): CreateAssetTypeSubsystemComponentClassRequestDto {
    return CreateAssetTypeSubsystemComponentClassRequestDtoFromJSONTyped(json, false);
}

export function CreateAssetTypeSubsystemComponentClassRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetTypeSubsystemComponentClassRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'associatedComponentClassIds': json['associatedComponentClassIds'],
    };
}

export function CreateAssetTypeSubsystemComponentClassRequestDtoToJSON(json: any): CreateAssetTypeSubsystemComponentClassRequestDto {
    return CreateAssetTypeSubsystemComponentClassRequestDtoToJSONTyped(json, false);
}

export function CreateAssetTypeSubsystemComponentClassRequestDtoToJSONTyped(value?: CreateAssetTypeSubsystemComponentClassRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'associatedComponentClassIds': value['associatedComponentClassIds'],
    };
}

